<template>
  <div>
      <v-toolbar card dense light flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <!-- <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title> -->
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout v-show="cxt.isFilterMode() && cxt.isSelectMode()" style="overflow:hidden" justify-end>
          </v-layout>
          <v-flex v-show="cxt.isFilterMode()" sm4 xs4>
            <v-text-field
              label="Фильтр"
              v-show="cxt.isFilterMode()"
              :value="cxt.filterString"
              v-on:input="onChangeFilter"
              solo flat
            ></v-text-field>
          </v-flex>
      </v-toolbar>
      <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="isSearching" :indeterminate="true"></v-progress-linear>
       <v-card-text>
          <v-layout row>
            <v-layout column>
              <v-text-field
                autofocus
                label="Введите запрос"
                hint="Название, ИНН, руководитель, учредитель, адрес"
                :value="getRequest"
                v-on:input="setRequest"
                clearable
                persistent-hint
                @keyup.enter.native="search"
              ></v-text-field>
            </v-layout>
            <v-layout column>
              <v-btn @click="search" :disabled="isSearching">Искать</v-btn>
            </v-layout>
          </v-layout>
      </v-card-text>
      <v-card-scroll :height="calcDialogScroll(48+48+52+102, 48+48+52+116+2)" v-on:nextPage="nextPage">
          <v-list
          three-line dense>
            <template v-for="item in this.filteredItems">
              <v-list-tile v-bind:key="getItemKey(item)"  @click.stop="select(item)">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="renderReference(item.ref, '_blank')"></v-list-tile-title>
                    <v-list-tile-sub-title>
                    {{renderHeads(item.ref)}}
                    <br/>
                    ИНН: <span v-html="renderInnOrInnflHtml(item.ref.inn)"></span>
                    <span style="white-space: normal;"> {{formats.blank(item.ref.address)}}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                <span>
                  <v-icon v-show="item.accountId">star</v-icon>
                  <v-icon v-show="!item.accountId"></v-icon>
                  <v-icon v-show="item.ref.clientId">person</v-icon>
                  <v-icon v-show="!item.ref.clientId"></v-icon>
                  <v-icon v-if="radio" v-show="cxt.check(getItemKey(item))">radio_button_checked</v-icon>
                  <v-icon v-if="radio" v-show="cxt.uncheck(getItemKey(item))">radio_button_unchecked</v-icon>
                  <v-icon v-if="!radio" v-show="cxt.check(getItemKey(item))">check_box</v-icon>
                  <v-icon v-if="!radio" v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
                </span>
                <v-list-tile-action-text>{{formats.blank(item.ref.createDate, formats.formatDate)}}</v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
      </v-card-scroll>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import classes from '../../api/classes'
  import apimix from '../common/apimix'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'search-selector-tab',
    components: {vCardScroll},
    mixins: [apimix],
    data: () => ({
      request: '',
      tagIds: [],
      cxt: null
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.mode = classes.modes.SELECT
      cxt.filterMode = true
      this.cxt = cxt
    },
    mounted () {
      this.request = this.query ? this.query : (this.getItemSet ? this.getItemSet.getFilter().search : '')
      this.changeFilterContext({search: this.request})
      this.processMethodsQueue()
    },
    watch: {
      query () {
        this.request = this.query
      },
      selected (newVal, oldVal) {
        this.cxt.setSelected(newVal)
      },
      methodsQueue () {
        this.processMethodsQueue()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      partner: {
        type: Boolean,
        default: false
      },
      query: {
        type: String,
        default: null
      },
      selected: {
        type: Array,
        default: []
      },
      methodsQueue: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getItemSet: 'getSearchSet',
        getProfileHaveClient: 'getProfileHaveClient',
        renderReference: 'renderReference',
        renderHeads: 'renderHeads',
        calcDialogScroll: 'calcDialogScroll',
        getTags: 'getTags',
        renderInnOrInnflHtml: 'renderInnOrInnflHtml'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + ' первых' : ''
        }
      },
      items () {
        return []
      },
      getRequest () {
        return this.request
      },
      orderedItems () {
        return this.getItemSet.getItems()
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.ref.ref,
              item.ref.caption,
              item.ref.name,
              this.renderHeads(item.ref),
              item.ref.inn,
              item.ref.kpp,
              // this.formatDate(item.company.createDate),
              // this.formatDate(item.company.releaseDate),
              item.ref.address,
              item.notes,
              item.privateNotes)
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 0) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      },
      isSearching () {
        return this.getItemSet.isProcessing()
      },
      getSearchTotal () {
        return this.getItemSet.getLoadedSize()
      }
    },
    methods: {
      processMethodsQueue () {
        if (!this.methodsQueue) return
        let len = this.methodsQueue.length
        for (let i = 0; i < len; i++) {
          let method = this.methodsQueue.shift()
          if (this[method.name]) {
            this[method.name](method.params)
          }
        }
      },
      checkAll () {
        this.cxt.checkAll()
        this.$emit('input', this.cxt.selected())
      },
      nextPage () {
        this.$store.commit('nextSearchCompanies')
        this.$store.dispatch('fetchSearchCompanies')
      },
      setRequest (v) {
        this.request = v
      },
      changeFilterContext (ops, force) {
        var self = this
        this.$store.commit('setSearchFilterContext', Object.assign({}, ops))
        setTimeout(() => {
          self.$store.dispatch('fetchSearchCompanies', force)
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
      },
      fetchData () {
        this.changeFilterContext({search: this.request, isShowOther: false}, true)
      },
      getItemKey (item) {
        return item.ref.ref + '_' + item.ref.inn
      },
      search: function () {
        if (!this.isSearching) {
          this.item = null
          this.fetchData()
        }
      },
      select (item) {
        if ((this.partner && !item.ref.clientId)) {
          return
        }
        var uid = this.getItemKey(item)
        if (this.cxt.uncheck(uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid)
        this.$emit('input', this.cxt.selected())
      }
    }

  }

</script>



// WEBPACK FOOTER //
// SearchSelectorTab.vue?24379af2